// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__33ERW","list_item":"styles_list_item__1Tmwp","more":"styles_more__1f8KX"};